
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { ComponentType, ReactElement } from 'react';
import styled from '@emotion/styled';
import Head from 'next/head';
import { H1, H2 } from 'library/atoms/Typography';
import Examples from './Examples';
import StyleGuideMenu from './StyleGuideMenu';
import Text from 'library/atoms/Typography/Text';
import { ILiveCode } from 'shared/library/molecules/EmbedCode/LiveCode';
import Flex from 'shared/library/atoms/Flex';
import Icon from 'shared/library/atoms/Icon';
/**
 * Parameters inserted by [id].tsx
 */
export type StyleGuideIdProps = {
    slug: string;
    title: string;
};
type StyleGuideProps = StyleGuideIdProps & {
    children: ReactElement;
};
/**
 * Parameters inserted by .StyleGuide.tsx
 */
export interface StyleGuideMainProps extends StyleGuideIdProps {
    Description: ComponentType;
    examples?: ILiveCode[] | null;
}
const generateMainTitle = (title: string) => {
    const currentYear = new Date().getFullYear();
    const mainTitle = `eola Style Guide ${currentYear}: ${title}`;
    return { mainTitle };
};
const StyleGuide = ({ slug, title, children }: StyleGuideProps) => {
    const { mainTitle } = generateMainTitle(title);
    return (<Flex flexDirection="column" width={1}>
      <Head>
        <title>{mainTitle}</title>
      </Head>
      <StyledHeader>
        <Icon name="logo" color="grey" size={70}/>
        <Text fontStyle="p4" color="tertiary">
          {mainTitle}
        </Text>
      </StyledHeader>
      <StyledLayout variant={slug}>
        <StyleGuideMenu />
        {children}
      </StyledLayout>
    </Flex>);
};
export const StyleGuideMain = ({ title, Description, examples }: StyleGuideMainProps) => (<main>
    <H1>{title}</H1>
    <Description />
    {examples && (<>
        <H2 mb={4} mt={9}>
          Examples
        </H2>
        <Examples examples={examples}/>
      </>)}
  </main>);
export default StyleGuide;
const StyledLayout = styled('div')<{
    variant: string;
}>(({ theme, variant }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 0,
    main: {
        flex: '1 0 0',
        padding: variant !== 'home' ? theme.space[8] : 0,
        height: 'auto',
        background: theme.colors.background.primary,
        '& > div + div': {
            marginTop: theme.space[5]
        }
    },
    '@media (min-width: 780px)': {
        flexDirection: 'row'
    }
}));
const StyledHeader = styled.header(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.space[5],
    height: theme.space[9]
}));

    async function __Next_Translate__getStaticProps__197303e4e2b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'shared/library//StyleGuide/StyleGuide',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197303e4e2b__ as getStaticProps }
  